module.exports = __webpack_public_path__ + "img/IGT.c6b251e5.png";